/** A coluna da escada lista as famílias de UMA companhia — a de marketing da
 *  perna, que é de quem é o programa tarifário (DL 6057 operado pela LATAM vende
 *  famílias Delta). Sem o nome na coluna, quem lê assume a companhia errada e
 *  conclui que a escada mente (foi exatamente o print que abriu o estudo). */
export type LegCarriers = readonly [string | undefined, string | undefined];

/** O formatador de baixo nível: junta base + companhia, ou devolve a base pura
 *  quando não há companhia resolvida (`undefined` ou `''` — nunca inventa). */
export function ladderColumnLabel(base: string, carrier: string | undefined): string {
  return carrier ? `${base} · ${carrier}` : base;
}

/** A decisão INTEIRA do rótulo de UMA coluna — pura, pra o componente só
 *  encadear a prop. Ordem de prioridade:
 *  1. `solo`: rótulo já composto pelo HOST (ex. "Trecho N" do multi-trecho).
 *     Sem coluna irmã, não há o que desambiguar — vence sem sufixo.
 *  2. `bundled`: escada única de combos. O par pode ter DUAS companhias, então
 *     a lista não é de nenhuma delas sozinha — sem sufixo.
 *  3. Caso comum (Ida/Volta em par): `base` ganha `" · " + carrier` quando a
 *     companhia foi resolvida — é exatamente a ambiguidade do print que abriu
 *     o estudo (Ida de uma cia ao lado de Volta de outra). */
export function resolveLadderColumnLabel(input: {
  base: string;
  carrier: string | undefined;
  solo: string | null;
  bundled: boolean;
}): string {
  if (input.solo) return input.solo;
  if (input.bundled) return input.base;
  return ladderColumnLabel(input.base, input.carrier);
}
